import m from "../../es2015/lang/ro_RO";
window.am4lang_ro_RO = m;


//////////////////
// WEBPACK FOOTER
// ./lang/ro_RO.js
// module id = null
// module chunks = 